import { render, staticRenderFns } from "./DownvotePopUp.vue?vue&type=template&id=2463c510&"
import script from "./DownvotePopUp.vue?vue&type=script&lang=ts&"
export * from "./DownvotePopUp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports